<template>
	<main
		id="archive-posts"
		class="archive single page main"
		:class="'archive-' + currentPostType"
		:key="'archive-' + currentPostType"
	>
		<PageHeader @onArchiveFilterUpdate="filtersUpdate" is-archive archive="posts" style="margin-bottom-lg" />

		<ModuleBuilder />

		<div class="archive-wrapp content-padding">
			<PostsGrid
				:type="currentPostType"
				:posts="postsToShow.slice(0, toShowCount)"
				class="margin-top-xl container"
			/>

			<div
				v-if="isMoreToShow && postsToShow.length"
				class="margin-bottom-xl margin-top-lg load-more-button text-center"
			>
				<Button
					aria-label="Load more elements"
					icon="arrowDown"
					icon-type="down"
					:outlined="false"
					uppercase
					v-observe-visibility="visibilityChanged"
					theme="dark"
					@click.native="loadMore()"
				>
					Show more news
				</Button>
			</div>
			<div
				v-if="postsLoaded && !isMoreToShow && postsToShow.length == 0"
				class="container no-resultats margin-bottom-lg text-center"
			>
				<template>
					<div class="inner-error font-size--30 margin-top-xl">Nothing found, try differnt filters</div>
				</template>
			</div>
		</div>
	</main>
</template>

<script>
import PostsGrid from '@/components/parts/PostsGrid'
import Button from '@/components/elements/Button'
import PageHeader from '@/components/parts/PageHeader'
import ModuleBuilder from '@/components/ModuleBuilder'
import _orderBy from 'lodash.orderby'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
	name: 'archive-page',
	components: {
		PostsGrid,
		Button,
		PageHeader,
		ModuleBuilder,
	},
	data() {
		return {
			selectedCategory: '',
			postsLoaded: false,
			filters: {
				category: '',
				event_category: '',
				event_color_category: '',
				internal_only: false,
				past_events: false,
			},
			posts: [],
			paged: 1,
			toShowDefault: 9,
			toShowCount: 9,
			showBy: 9,
			countAll: 0,
		}
	},
	watch: {
		postsLoaded(val) {
			// if(val){
			// 	const urlFilters = Object.assign({}, this.$route.query);
			// 	let query = {}
			// 	if(Object.keys(urlFilters).length ){
			// 		if(urlFilters.hasOwnProperty('category_ambasador')){
			// 			query = {...query, ... urlFilters }
			// 		}
			// 		if(urlFilters.hasOwnProperty('category')){
			// 			query = {...query, ... urlFilters }
			// 		}
			// 		//consoleconsole.log(query)
			// 	}
			// 	//trigger first router/filters action
			// }
		},
	},
	mounted() {
		this.loadPosts()
		this.loadTaxonomies()
		//console.log(this.$route)
	},
	methods: {
		...mapActions(['getPost', 'getTaxonomy']),
		...mapMutations(['SET_LOADED_TAXONOMIES']),
		loadTaxonomies() {
			const VM = this
			Promise.all([this.getTaxonomy('category'), this.getTaxonomy('event_category')]).then(function (values) {
				VM.SET_LOADED_TAXONOMIES()
			})
		},
		filtersUpdate(value) {
			this.filters[value.action] = value.value
		},
		loadPosts() {
			const VM = this
			VM.getPost(VM.apiOptLoad).then((res) => {
				const { posts } = res.data
				if (posts && posts.length) {
					VM.countAll = posts.length
					VM.posts = posts
					VM.postsLoaded = true
				}
			})
		},
		loadMore() {
			this.toShowCount = this.toShowCount + this.showBy
		},
		visibilityChanged(isVisible) {
			if (isVisible) {
				this.loadMore()
			}
		},
	},
	computed: {
		...mapGetters(['storedTaxonomy', 'currentPostType', 'currentPage', 'storedTaxonomyBySlug']),
		apiOptLoad() {
			let opt = {
				type: this.currentPostType || 'post',
				order_by: 'date',
				order: 'DESC',
				all_events: true,
				limit: 5000,
			}
			if (this.currentPostType === 'events') opt.all_events = true
			return opt
		},

		isMoreToShow() {
			return this.toShowCount < this.postsToShow.length
		},
		postsToShow() {
			const VM = this
			const now = new Date().setHours(0, 0, 0, 0)

			if (!this.posts) return false

			let toShow = VM.posts
				.filter((p, i) => {
					//search
					const searchQuery = VM.filters.search
					let showMe = true
					if (searchQuery) showMe = p.title.toUpperCase().indexOf(searchQuery.toUpperCase()) > -1
					return showMe
				})
				.filter((p, i) => {
					// post category
					if (VM.filters.category && VM.filters.category) {
						const postCategory = p.acf && p.acf.post_category ? p.acf.post_category : false
						return postCategory && postCategory.id === VM.filters.category
					}
					return true
				})
				.filter((p, i) => {
					// events category
					let canMeShow = true
					if (this.currentPostType === 'events' && p.type === 'events' && p.acf && p.acf.event_datetime) {
						let endTime = p.acf.event_datetime.substring(0, 10)
						if (p.acf.event_datetime_copy) {
							endTime = p.acf.event_datetime_copy.substring(0, 10)
						}
						endTime =
							endTime.substring(0, 4) + '-' + endTime.substring(4, 6) + '-' + endTime.substring(6, 8)
						endTime = new Date(endTime).getTime()

						if (this.filters.past_events) canMeShow = endTime < now
						else canMeShow = endTime >= now

						if (canMeShow && VM.filters.event_color_category && VM.filters.event_color_category) {
							const postCategory = p.acf && p.acf.category ? p.acf.category : false
							canMeShow = postCategory && postCategory === VM.filters.event_color_category
						}

						if (canMeShow && VM.filters.internal_only) {
							canMeShow = p.acf && p.acf.org_type === 'internal'
						}

						if (canMeShow && VM.filters.event_category && VM.filters.event_category) {
							const postCategory = p.acf && p.acf.type ? p.acf.type : false
							canMeShow = postCategory && Number(postCategory.id) === VM.filters.event_category
						}
					}
					return canMeShow
				})

			if (toShow && toShow.length && this.currentPostType === 'events' && this.filters.past_events === false) {
				toShow = _orderBy(toShow, 'acf.event_datetime', 'asc')
			}
			if (toShow && toShow.length && this.currentPostType === 'events' && this.filters.past_events !== false) {
				toShow = _orderBy(toShow, 'acf.event_datetime', 'desc')
			}

			return toShow && toShow.length ? toShow : []
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.archive {
	.events-list {
		padding-bottom: 2px;
	}
}
</style>
